{
  "loading": "Se încarcă...",
  "loadingMore": "Se încarcă mai multe..."
}